import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Grid, Flex, Loader } from 'nallian-shared-ui/lib/components';
import FormHeader from '../../../../../portal/app/components/FormHeader';
import UserGroupCard from './UserGroupCard';

const Container = styled.div`
  width: 100%;
  margin-bottom: 1.5rem;
`;

const EmptyState = styled.div`
  color: #6a737d;
  font-style: italic;
  padding: 2rem;
  font-size: 0.95em;
  text-align: center;
  background-color: #f6f8fa;
  border-radius: 6px;
  border: 2px dashed #d1d5da;
`;

const UserGroupRolesDisplay = ({ userGroupsDetails, loading, selectedUserGroupIds }) => {
  const { t } = useTranslation();

  // Don't render if no user groups are selected
  if (!selectedUserGroupIds || selectedUserGroupIds.length === 0) {
    return null;
  }

  return (
    <>
      <FormHeader content={t('rolesFromUserGroups')} />
      <Grid.Column mobile={16} tablet={16} computer={16}>
        {loading ? (
          <Flex fluid justifyContent="center" padding="2rem 0">
            <Loader active inline="centered" />
          </Flex>
        ) : (
          <Container>
            {userGroupsDetails && userGroupsDetails.length > 0 ? (
              userGroupsDetails.map(userGroup => (
                <UserGroupCard key={userGroup.id} userGroup={userGroup} />
              ))
            ) : (
              <EmptyState>{t('noRolesInSelectedUserGroups')}</EmptyState>
            )}
          </Container>
        )}
      </Grid.Column>
    </>
  );
};

UserGroupRolesDisplay.propTypes = {
  userGroupsDetails: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      apps: PropTypes.arrayOf(
        PropTypes.shape({
          communityTag: PropTypes.string,
          installationTag: PropTypes.string,
          features: PropTypes.arrayOf(
            PropTypes.shape({
              id: PropTypes.string,
              tag: PropTypes.string,
              alias: PropTypes.string,
              name: PropTypes.string,
              roles: PropTypes.arrayOf(
                PropTypes.shape({
                  id: PropTypes.string,
                  tag: PropTypes.string,
                  alias: PropTypes.string,
                  name: PropTypes.string,
                })
              ),
            })
          ),
        })
      ),
    })
  ),
  loading: PropTypes.bool,
  selectedUserGroupIds: PropTypes.arrayOf(PropTypes.string),
};

UserGroupRolesDisplay.defaultProps = {
  userGroupsDetails: [],
  loading: false,
  selectedUserGroupIds: [],
};

export default UserGroupRolesDisplay;
